/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ImageStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M2.45455 18.6667L6.54545 13.7778L10.1818 17.3333L16.5455 10.2222L22 16.4444M4.90909 4H19.0909C20.1092 4 20.6183 4 21.0073 4.19377C21.3494 4.36421 21.6275 4.63617 21.8018 4.97068C22 5.35097 22 5.8488 22 6.84444V17.1556C22 18.1512 22 18.649 21.8018 19.0293C21.6275 19.3638 21.3494 19.6358 21.0073 19.8062C20.6183 20 20.1092 20 19.0909 20H4.90909C3.89081 20 3.38168 20 2.99274 19.8062C2.65063 19.6358 2.37249 19.3638 2.19817 19.0293C2 18.649 2 18.1512 2 17.1556V6.84444C2 5.8488 2 5.35097 2.19817 4.97068C2.37249 4.63617 2.65063 4.36421 2.99274 4.19377C3.38168 4 3.89081 4 4.90909 4ZM11.0909 8.44444C11.0909 9.42628 10.2769 10.2222 9.27273 10.2222C8.26857 10.2222 7.45455 9.42628 7.45455 8.44444C7.45455 7.4626 8.26857 6.66667 9.27273 6.66667C10.2769 6.66667 11.0909 7.4626 11.0909 8.44444Z"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { ImageStrokeIcon };
